// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"d15e9060","511":"7301948d"}[chunkId] + ".chunk.js";
};